module.exports = __webpack_public_path__ + "img/40_69_011_690.4fe59aa5.jpg";